"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaraivaTheme = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Componente responsável por implementar o tema da aplicação, deve utilizado na raíz da árvore de componentes da aplicação.
 */
var SaraivaTheme = function SaraivaTheme(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), children);
};

exports.SaraivaTheme = SaraivaTheme;
SaraivaTheme.propTypes = {
  children: _propTypes.default.node
};
SaraivaTheme.defaultProps = {
  children: null
};